<template>
  <div class="SayfaContainer">
    <div class="SayfaBaslik">
      <h1>Bina İşlemleri</h1>
      <div class="SayfaBtn el-button-group">
        <el-button size="small" type="primary" :loading="lo" @click="Gonder">Kaydet</el-button>
      </div>
    </div>
    <div class="SayfaIcerik SayfaTable" v-loading="lo">
      <el-form v-loading="lo" status-icon :model="Form" @submit.prevent.native="Gonder" :rules="FormHata"
               ref="Form">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Firma Adı" prop="firma">
              <el-input type="text" v-model="Form.firma" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Vergi Dairesi" prop="vDaire">
              <el-input type="text" v-model="Form.vdaire" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Vergi No" prop="vNo">
              <el-input type="text" v-model="Form.vno" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>


          <el-col :span="12">
            <el-form-item label="Email" prop="email">
              <el-input type="text" v-model="Form.email" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Telefon" prop="telefon">
              <el-input type="text" v-model="Form.telefon" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Adres" prop="adres">
              <el-input type="textarea" v-model="Form.adres" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      ModalBaslik: '',
      lo: false,
      Form: {
        adi: null
      },
      Bolgeler: null,
      FormHata: {
        adi: [{required: true, message: "Bina Adı Giriniz", trigger: 'blur'}],
        Bolge_id: [{required: true, message: "Bölge Seçiniz", trigger: 'blur'}],
        adres: [{required: true, message: "Adres Giriniz", trigger: 'blur'}],
      },
    }
  },
  methods: {

    Gonder() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true

          this.$store.dispatch("Put", {...this.Form, path: 'ayarlar'})
              .then(response => {
                console.log(response)
                if (response.Durum == "OK") {
                  this.$emit('Durum')
                  this.$notify.success({
                    title: response.Mesaj,
                    customClass: 'success'
                  });
                  this.lo = false
                } else {
                  this.$notify.error({
                    title: response.Mesaj,
                    customClass: 'error'
                  });
                  this.lo = false
                }
              })
        }
      })

    }
  },
  created() {
    this.$store.dispatch("Get", {path: 'ayarlar'})
        .then(response => {
          this.Form = response.Data
        })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Ayarlar/Index.vue